import {
  azure,
  gray,
  green,
  lime,
  magenta,
  orange,
  purple,
  red,
  teal,
  yellow,
} from '../themes/foundation-colors';
import { readableColor, toHex } from 'color2k';

export const variant = {
  'orange-04': {
    background: '#FFDDB6',
    text: toHex(orange[14]),
    icon: toHex(orange[14]),
  },
  'yellow-04': {
    background: '#FFEF9D',
    text: toHex(yellow[15]),
    icon: toHex(yellow[15]),
  },
  'lime-05': {
    background: '#9DFEA0',
    text: toHex(lime[15]),
    icon: toHex(lime[15]),
  },
  'green-05': {
    background: '#92FEC2',
    text: toHex(green[14]),
    icon: toHex(green[14]),
  },
  'teal-05': {
    background: '#AAF6EF',
    text: toHex(teal[14]),
    icon: toHex(teal[14]),
  },
  'azure-04': {
    background: '#E0F0FF',
    text: toHex(azure[15]),
    icon: toHex(azure[15]),
  },
  'purple-06': {
    background: '#E4DEFF',
    text: toHex(purple[16]),
    icon: toHex(purple[16]),
  },
  'magenta-06': {
    background: '#FBD7FB',
    text: toHex(magenta[15]),
    icon: toHex(magenta[15]),
  },
  'red-06': {
    background: '#FEDAD9',
    text: toHex(red[14]),
    icon: toHex(red[14]),
  },

  'red-10': { background: '#FD817A', text: toHex(red[1]), icon: toHex(red[1]) },
  'orange-06': {
    background: '#E5A500',
    text: toHex(orange[1]),
    icon: toHex(orange[1]),
  },
  'lime-10': {
    background: '#20CF27',
    text: toHex(lime[1]),
    icon: toHex(lime[1]),
  },
  'green-10': {
    background: '#2ED389',
    text: toHex(green[1]),
    icon: toHex(green[1]),
  },
  'teal-10': {
    background: '#1EC7BC',
    text: toHex(teal[1]),
    icon: toHex(teal[1]),
  },
  'azure-10': {
    background: '#51C0FF',
    text: toHex(gray[16]),
    icon: toHex(gray[16]),
  },
  'purple-10': {
    background: '#AA95FF',
    text: toHex(purple[1]),
    icon: toHex(purple[1]),
  },
  'magenta-10': {
    background: '#F68DF6',
    text: toHex(magenta[1]),
    icon: toHex(magenta[1]),
  },
};

export const subtle = [
  variant['orange-04'].background,
  variant['yellow-04'].background,
  variant['lime-05'].background,
  variant['green-05'].background,
  variant['teal-05'].background,
  variant['azure-04'].background,
  variant['purple-06'].background,
  variant['magenta-06'].background,
  variant['red-06'].background,
];

export const solid = [
  variant['red-10'].background,
  variant['orange-06'].background,
  variant['lime-10'].background,
  variant['green-10'].background,
  variant['teal-10'].background,
  variant['azure-10'].background,
  variant['purple-10'].background,
  variant['magenta-10'].background,
];

export function getVariantName(color) {
  // Find the key where the background color matches
  return (
    Object.keys(variant).find(key => variant[key].background === color) || ''
  );
}

export function getCsBadgeVariant(color) {
  const variantName = getVariantName(color);

  // Map color variant names to CsBadge variants
  const badgeVariantMap = {
    'azure-04': 'info',
    'yellow-04': 'attention',
    'red-06': 'critical',
  };

  return badgeVariantMap[variantName] || 'custom';
}

export function getCsBadgeCustomStyle(color) {
  const variantName = getVariantName(color);

  if (variantName) {
    return {
      backgroundColor: variant[variantName].background,
      color: variant[variantName].text,
    };
  }

  return {
    backgroundColor: color,
    color: toHex(readableColor(color)),
  };
}

export function isColorPredefined(color) {
  return subtle.includes(color) || solid.includes(color);
}

export function getColorType(color) {
  if (subtle.includes(color)) {
    return 'subtle';
  }

  if (solid.includes(color)) {
    return 'solid';
  }

  return 'custom';
}
